import { IAuthUser } from 'auth/types';
import { AccessPermissions } from 'core/enums';
import { hasPermission } from 'router/utils';

export const canAccessPartFinder = (user?: IAuthUser | null): boolean =>
  hasPermission([AccessPermissions.ACCESS_PART_FINDER], user?.resources ?? []);
